import { render, staticRenderFns } from "./GExamenClinico.vue?vue&type=template&id=9f153976"
import script from "./GExamenClinico.vue?vue&type=script&lang=ts"
export * from "./GExamenClinico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports